'use client';

import { db } from '@/api/firebase';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/components/ui/use-toast';
import { useMainContext } from '@/context/main-context';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { useForm } from 'react-hook-form';

export default function AddBranchDialog({ open, setOpen }) {
  const { uid } = useMainContext();
  const { toast } = useToast();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    defaultValues: {
      name: '',
      address: '',
      phone: '',
    },
  });

  const onSubmit = async (data) => {
    try {
      const branchRef = collection(db, 'users', uid, 'branches');
      const newBranch = await addDoc(branchRef, {
        name: data.name,
        address: data.address,
        createdAt: serverTimestamp(),
      });

      const branchId = newBranch.id;
      console.log('New branch created:', branchId);

      reset();
      toast({ title: 'Yangi filial muvaffaqiyatli qo‘shildi!' });
      setOpen(false);

      return branchId;
    } catch (error) {
      console.error('Error adding branch:', error);
      throw error;
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-full max-w-xl">
        <DialogHeader>
          <DialogTitle>Yangi filial qo‘shish</DialogTitle>
          <DialogDescription>
            Iltimos, yangi filial ma’lumotlarini kiriting.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <Label htmlFor="name">Filial nomi</Label>
            <Input
              id="name"
              placeholder="Masalan: Chilonzor filial"
              {...register('name', {
                required: 'Filial nomi kiritilishi kerak',
              })}
              disabled={isSubmitting}
            />
            {errors.name && (
              <p className="text-sm text-red-500 mt-1">{errors.name.message}</p>
            )}
          </div>

          <div>
            <Label htmlFor="address">Manzil</Label>
            <Input
              id="address"
              placeholder="Masalan: Toshkent, Chilonzor-9"
              {...register('address', { required: 'Manzil kiritilishi kerak' })}
              disabled={isSubmitting}
            />
            {errors.address && (
              <p className="text-sm text-red-500 mt-1">
                {errors.address.message}
              </p>
            )}
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => setOpen(false)}
              disabled={isSubmitting}
            >
              Bekor qilish
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              Saqlash
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
